<template>
  <div class="order-history">

    <b-row class="mb-4">
      <!-- General information -->
      <b-col cols="12" lg="6">
        <b-card>
          <b-card-title class="text-uppercase">Informatie</b-card-title>
          <b-table-simple small>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <b-tbody>
              <b-tr>
                <b-th>Ordernummer</b-th>
                <b-td>{{ salesOrder.identifier }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Geplaatst op</b-th>
                <b-td>{{ datetime(salesOrder.created_at) }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <!-- List with order processing history -->
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12">
              <b-card-title class="text-uppercase">
                Geschiedenis
              </b-card-title>

              <template v-if="loadingOrderHistory">
                <span class="icon mr-2">
                  <font-awesome-icon icon="spinner" spin/>
                </span>
                <span class="label">
                  Bezig met laden van de ordergeschiedenis&hellip;
                </span>
              </template>

              <template v-else-if="orderHistoryAvailable">
                <b-table
                  :selectable="false"
                  :items="orderHistoryProcessed"
                  :fields="this.displayPrefs.orderHistory.fields"
                  select-mode="single"
                  stacked="sm"
                />
              </template>

              <template v-else>
                <p class="mt-3">Er is geen geschiedenis beschikbaar.</p>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import _ from 'lodash';
import { date, datetime } from "@/helpers/date";
import { price } from "@/helpers/numbers";

export default {
  props: {
    salesOrder: {
      required: true,
    },
  },
  data() {
    return {
      // Loading state(s)
      loadingOrderHistory: false,

      // Display Preferences, i.e. how the data in the table(s) are presented.
      displayPrefs: {
        orderHistory: {
          fields: [
            /**
             * @see https://bootstrap-vue.org/docs/components/table#fields-as-an-array-of-objects
             */
            {
              key: 'data_type',
              label: 'Type',
              formatter: (value, key, item) => {
                return this.$t(`omt.gui.orders.order-history.label.${value}`)
              }
            },
            {
              key: 'name',
              label: 'Naam',
              formatter: (value, key, item) => {
                return this.$t(`omt.gui.orders.order-history.label.${value}`)
              }
            },
            {
              key: 'created_at',
              label: 'Datum',
              sortable: true,
              formatter: (value, key, item) => {
                return value !== null ? datetime(value) : '';
              },
            },
            {
              key: 'archived_at',
              label: 'Gearchiveerd op',
              sortable: true,
              formatter: (value, key, item) => {
                return value !== null ? datetime(value) : '';
              },
            },
            {
              key: 'status_identifier',
              label: 'Status',
              formatter: (value, key, item) => {
                if (!value) { return; }
                return this.$t(`omt.gui.orders.order-history.label.${value}`)
              }
            },
          ],
        }
      },

      // Actual data
      orderHistory: []
    };
  },
  methods: {
    datetime,
    price,
    fetchOrderHistory() {
      // Fetches the order history from the API.
      if (!this.salesOrder.identifier) {
        throw new Error('Sales order identifier is required, but not available.');
      }

      const endpoint = `/api/rest/sales-orders/${this.salesOrder.identifier}/history`;
      this.loadingOrderHistory = true;
      this.$http.get(endpoint)
        .then(response => {
          this.orderHistory = response.data;
        })
        .catch(error => {
          this.$alert('Er is iets misgegaan tijdens het ophalen van de geschiedenis van deze order.', 'danger');
          console.error(error);
        })
        .finally(() => {
          this.loadingOrderHistory = false;
        });
    },
  },
  computed: {
    orderHistoryAvailable() {
      return this.orderHistory.length > 0;
    },
    orderHistoryProcessed() {
      // Returns the order history, but puts the value either 'caused_by_processor_config_identifier', 'caused_by_status_identifier' or 'processor_config_identifier' into a single 'caused_by' property.
      return this.orderHistory.map(item => {
        const name = item.caused_by_processor_config_identifier || item.caused_by_status_identifier || item.processor_config_identifier;
        return {
          ...item,
          name
        };
      }); 
    },
  },
  mounted() {
    this.fetchOrderHistory();
  },
};
</script>